/**
 * @file admin-dashboard.tsx
 * @deprecated Copied to app/modules/procurement/pages/dashboard/admin-dashboard.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/dashboard/admin-dashboard
 * @description Implements the admin dashboard interface for UProcure operations.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { getKey } from "../../../../Global/history";
import Loader from "../../../../Global/loader";
import {
  AllModules,
  Dashboard,
  FinanceManager
} from "../../../../utils/constants";
import { IMAGES } from "../../../../utils/assetsAndPermissions";
import { warehouse as warehouseStoreString } from "../../../../utils/storeString";
import RequestReport from "./chart/request-report";
import VendorsReport from "./chart/vendors-report";
import { useAuth } from "../../auth";
import Method from "../../../../utils/methods";
import APICallService from "../../../../api/apiCallService";
import { AUTH, DASHBOARD, UPROCURE_DASHBOARD } from "../../../../api/apiEndPoints";
import OrdersReport from "./chart/orders-report";
import { useNavigate } from "react-router-dom";
import ErrorIcon from "../../../../_admin/assets/media/critical-errors.png";
import { useWarehouse } from "../../../context/WarehouseContext";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const { selectedWarehouse } = useWarehouse();
  const [loading, setLoading] = useState<boolean>(false);
  const [count, setCount] = useState<any>({});
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [notificationList, setNotificationList] = useState<any>([]);
  const [notificationLoader, setNotificationLoader] = useState(false);

  useEffect(() => {
    (async () => {
      await fetchDashboardData();
      await fetchNotification();
    })();
  }, [selectedWarehouse?.value]);
  const fetchDashboardData = async () => {
    let params: any = {
      needStats: true,
      needAllStats: true,
      fromDate: Method.convertDateToFormat(new Date(), "YYYY-MM-DD"),
      warehouse: selectedWarehouse?.value
    };
    setLoading(true);
    let apiService = new APICallService(
      UPROCURE_DASHBOARD,
      params,
      "",
      "",
      "",
      "",
      Dashboard,
      selectedWarehouse?.value
    );
    let response = await apiService.callAPI();
    if (response) {
      setCount(response.stats);
    }
    setLoading(false);
  };

  const fetchNotification = async () => {
    const params = {
      pageNo: 1,
      limit: 5,
      sortKey: "_createdAt",
      sortOrder: -1,
      type: 4,
      warehouse: selectedWarehouse?.value
    };
    setNotificationLoader(true);
    const apiCallService = new APICallService(
      AUTH.notification,
      params,
      "",
      "",
      "",
      "",
      AllModules,
      selectedWarehouse?.value
    );
    const response = await apiCallService.callAPI();
    if (response) {
      setNotificationList(response?.records || []);
    }
    setNotificationLoader(false);
  };

  return (
    <>
      <div className="p-5">
        {/* {showDownloadModal ? (
          <DashboardReport
            show={showDownloadModal}
            onHide={() => setShowDownloadModal(false)}
            moduleName={Dashboard}
          />
        ) : (
          <></>
        )} */}
        <Row className="mb-7 align-items-center">
          <Col xs className="fs-22 fw-bolder">
            Dashboard
          </Col>

          {/* {!loading ? (
            <>
              {" "}
              <Col sm="auto">
                <Button
                  variant=""
                  size="lg"
                  className="text-primary bg-light-primary min-h-50px"
                  onClick={() => setShowDownloadModal(true)}
                >
                  Download Report
                </Button>
              </Col>
            </>
          ) : (
            <></>
          )} */}
        </Row>
        {loading ? (
          <div className="w-100 d-flex justify-content-center">
            <Loader loading={loading} />
          </div>
        ) : (
          <>
            {" "}
            {/* Key Metrics Row 1 */}
            <Row className="align-items-center mb-7 g-6">
              <Col xl={3} md={6} sm={6}>
                <div className="border-r8px bg-c9f3d7 rounded py-4 px-5">
                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column">
                      <span className="fs-22 fw-bolder">
                        {count?.totalVendors || 0}
                      </span>
                      <span className="fw-medium fs-16">Total Vendors</span>
                    </div>
                    <img src={IMAGES.SellerSVG} alt="" />
                  </div>
                </div>
              </Col>

              <Col xl={3} md={6} sm={6}>
                <div
                  className="border-r8px rounded py-4 px-5"
                  style={{ backgroundColor: "#fff3e0", borderWidth: "2px" }}
                >
                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column">
                      <span className="fs-22 fw-bolder text-danger">
                        {count?.pendingKYC || 0}
                      </span>
                      <span className="fw-medium fs-16">KYC pending</span>
                    </div>
                    <div
                      className="d-flex align-items-center justify-content-center bg-danger rounded-circle"
                      style={{ width: "48px", height: "48px" }}
                    >
                      <i className="bi bi-exclamation-triangle text-white fs-3"></i>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xl={3} md={6} sm={6}>
                <div
                  className="border-r8px rounded py-4 px-5"
                  style={{ backgroundColor: "#e3f2fd" }}
                >
                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column">
                      <span className="fs-22 fw-bolder">
                        {count?.totalShipmentsRequests || 0}
                      </span>
                      <span className="fw-medium fs-16">Total POs</span>
                    </div>
                    <div
                      className="d-flex align-items-center justify-content-center bg-primary rounded-circle"
                      style={{ width: "48px", height: "48px" }}
                    >
                      <i className="bi bi-file-earmark-text text-white fs-3"></i>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xl={3} md={6} sm={6}>
                <div
                  className="border-r8px rounded py-4 px-5"
                  style={{ backgroundColor: "#fff9c4" }}
                >
                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column">
                      <span className="fs-22 fw-bolder text-warning">
                        {count?.pendingShipmentsRequests || 0}
                      </span>
                      <span className="fw-medium fs-16">Pending POs</span>
                    </div>
                    <div
                      className="d-flex align-items-center justify-content-center bg-warning rounded-circle"
                      style={{ width: "48px", height: "48px" }}
                    >
                      <i className="bi bi-clock text-white fs-3"></i>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            {/* Key Metrics Row 2 */}
            <Row className="align-items-center mb-7 g-6">
              <Col xl={3} md={6} sm={6}>
                <div
                  className="border-r8px rounded py-4 px-5"
                  style={{ backgroundColor: "#f0f0f0" }}
                >
                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column">
                      <span className="fs-22 fw-bolder text-muted">
                        {count?.completedShipmentsRequests || 0}
                      </span>
                      <span className="fw-medium fs-16">Completed POs</span>
                    </div>
                    <div
                      className="d-flex align-items-center justify-content-center bg-secondary rounded-circle"
                      style={{ width: "48px", height: "48px" }}
                    >
                      <i className="bi bi-check-all text-white fs-3"></i>
                    </div>
                  </div>
                </div>
              </Col>

              {/* <Col xl={3} md={6} sm={6}>
                <div className="border-r8px rounded py-4 px-5" style={{ backgroundColor: '#d1c4e9' }}>
                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column">
                      <span className="fs-22 fw-bolder">
                        {metrics.grnSummary || 0}
                      </span>
                      <span className="fw-medium fs-16">GRN Summary</span>
                    </div>
                    <div className="d-flex align-items-center justify-content-center rounded-circle" style={{ width: '48px', height: '48px', backgroundColor: '#9c27b0' }}>
                      <i className="bi bi-box-seam text-white fs-3"></i>
                    </div>
                  </div>
                </div>
              </Col> */}

              <Col xl={3} md={6} sm={6}>
                <div
                  className="border-r8px rounded py-4 px-5"
                  style={{ backgroundColor: "#c8e6c9" }}
                >
                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column">
                      <span className="fs-22 fw-bolder text-success">
                        {count?.totalEscalations || 0}
                      </span>
                      <span className="fw-medium fs-16">Total Escalations</span>
                    </div>
                    <div
                      className="d-flex align-items-center justify-content-center bg-success rounded-circle"
                      style={{ width: "48px", height: "48px" }}
                    >
                      <i className="bi bi-check-circle text-white fs-3"></i>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xl={3} md={6} sm={6}>
                {/* Empty space for future metric or keep for layout balance */}
              </Col>
            </Row>
            {notificationList && notificationList?.length > 0 && (
              <Row className="mb-7 mt-4 ">
                <Col xs={12}>
                  <Card className="border border-r10px">
                    <Card.Header className="d-flex justify-content-between align-items-center">
                      <h2 className="fs-22 fw-bolder">Critical Alerts</h2>
                      {notificationList?.length > 0 && (
                        <div
                          className="fs-16 fw-500 text-primary cursor-pointer d-inline-block"
                          onClick={() =>
                            navigate("/notifications", { state: { type: 4 } })
                          }
                        >
                          View All
                        </div>
                      )}
                    </Card.Header>
                    <Card.Body>
                      <Row>
                        <Col xs={12}></Col>
                        <Col xs={12}>
                          {!notificationLoader ? (
                            notificationList?.length > 0 ? (
                              notificationList.map(
                                (item: any, index: number) => {
                                  return (
                                    <>
                                      <div
                                        className="d-flex py-3 gap-8 fs-16 fw-500"
                                        onClick={() => {
                                          if (item?.metadata?.variantId) {
                                            navigate(
                                              "/products/master-products/view-product-details",
                                              {
                                                state:
                                                  item?.metadata?.variantId ||
                                                  "",
                                              }
                                            );
                                          }
                                        }}
                                      >
                                        <div>
                                          <img
                                            src={
                                              item?.type == 4
                                                ? ErrorIcon
                                                : item?.image || ""
                                            }
                                            alt="icon"
                                            height={35}
                                            width={35}
                                          />
                                        </div>
                                        <div>
                                          <div>{item?.message}</div>
                                          <div className="text-gray-700">
                                            {Method.convertDateToDDMMYYYYHHMMAMPMWithSeperator(
                                              item?._createdAt,
                                              " - "
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      {index !==
                                        notificationList.length - 1 && (
                                        <div className="separator my-5"></div>
                                      )}
                                    </>
                                  );
                                }
                              )
                            ) : (
                              <div className="min-h-200px d-flex justify-content-center align-items-center">
                                <p className="fs-16 fw-500">No Alerts Found</p>
                              </div>
                            )
                          ) : (
                            <div className="min-h-200px d-flex justify-content-center align-items-center">
                              <Loader loading={notificationLoader} />
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            )}
            <OrdersReport />
          </>
        )}
      </div>
    </>
  );
};
export default AdminDashboard;
